exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-0efb0173&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UniversityManage/EquipmentManage/EquipmentList/EquipmentBoxVenue/EquipmentBoxVenue.vue
// module id = 439
// module chunks = 0